import React, {Component} from "react";
import {Col, Grid, Row, Table} from "react-bootstrap";
import Card from "../../components/Card/Card";
import {ExportData} from "../../components/CustomExport/ExportData";

class ReportsExports extends Component {

    constructor(props) {

        super(props);
        this.state = {

            exportsArray: [
                {
                    "id": "1",
                    "title": "Channels",
                    "description": "Export full list of channels, this includes the ones in removed state",
                    "type": "channels"
                },
                {
                    "id": "2",
                    "title": "Customers",
                    "description": "Export full list of customers, this includes the ones in removed state",
                    "type": "customers"
                },
                {
                    "id": "3",
                    "title": "Devices",
                    "description": "Export full list of devices, this includes the ones in removed state",
                    "type": "devices"
                },
                {
                    "id": "4",
                    "title": "TVOD",
                    "description": "Export full list of TVOD titles, this includes the ones in removed state",
                    "type": "tvod"
                },
                {
                    "id": "5",
                    "title": "SVOD",
                    "description": "Export full list of SVOD titles, this includes the ones in removed state",
                    "type": "svod"
                },
                {
                    "id": "6",
                    "title": "AVOD",
                    "description": "Export full list of AVOD titles, this includes the ones in removed state",
                    "type": "avod"
                },
                {
                    "id": "7",
                    "title": "Video categories",
                    "description": "Export full list of Video Categories",
                    "type": "vodCategories"
                },
                {
                    "id": "8",
                    "title": "Series All",
                    "description": "Export full list of TV Series",
                    "type": "tv_series_all"
                },
                {
                    "id": "9",
                    "title": "Seasons All",
                    "description": "Export full list of TV Series -> Seasons",
                    "type": "tv_series_all_seasons"
                },
                {
                    "id": "10",
                    "title": "Episodes All",
                    "description": "Export full list of TV Series -> Episodes",
                    "type": "tv_series_all_episodes"
                },
                {
                    "id": "11",
                    "title": "Customer - Package Status",
                    "description": "Export full list of all customers and their corresponding packages both active and expired",
                    "type": "customers_expire"
                },
                {
                    "id": "12",
                    "title": "Applications",
                    "description": "Export full list of all Applications",
                    "type": "applications"
                },
                {
                    "id": "13",
                    "title": "Radio Statios",
                    "description": "Export full list of all radio stations",
                    "type": "radio"
                },
                {
                    "id": "14",
                    "title": "EAS Alerts",
                    "description": "Export full list of all alerts",
                    "type": "eas_alerts"
                }
            ]
        }
    }

    render() {
        return (
            <div className="main-content">

                <Card
                    tableFullWidth
                    content={
                        <div>
                            <Grid fluid>
                                <h5>Exports</h5>
                                <legend/>
                                <Row>
                                    <Col sm={12}>
                                        <Row>
                                            <Table striped={true} responsive={true} hover={true}>
                                                <thead>
                                                <tr>
                                                    <th className="text-center">ID</th>
                                                    <th className="text-center">Title</th>
                                                    <th>Description</th>
                                                    <th className="text-center">Export</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    this.state.exportsArray.map((exportItem) => {
                                                        return (
                                                            <tr key={exportItem.id}>
                                                                <td className="text-center">{exportItem.id}</td>
                                                                <td className="text-center">{exportItem.title}</td>
                                                                <td>{exportItem.description}</td>
                                                                <td className="text-center">
                                                                    <ExportData
                                                                        exportDataFor={exportItem.type}
                                                                    />
                                                                </td>

                                                            </tr>
                                                        );
                                                    })
                                                }
                                                </tbody>
                                            </Table>
                                        </Row>
                                    </Col>
                                </Row>
                            </Grid>
                        </div>
                    }
                />

            </div>
        );
    }
}

export default ReportsExports;
